import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { showNotification } from '@/utils/notificationUtils';

export type MakePaymentDTO = {
  data: {
    token: string,
    cardToken?: string,
    paymentIntentId?:string,
  };
};

export const makePayment = ({ data }: MakePaymentDTO) => {
  return axios.post(`/payment/complete/${data.token}`, { cardToken: data.cardToken, paymentIntentId: data.paymentIntentId });
};

type UseMakePaymentOptions = {
  config?: MutationConfig<typeof makePayment>;
};

export const useMakePaymentMutation = ({ config }: UseMakePaymentOptions = {}) => {
  return useMutation({
    onSuccess: () => {
      showNotification({
        type: 'success',
        title: 'Payment successful',
      });
    },
    ...config,
    mutationFn: makePayment,
  });
};
